import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M12 22.043a46.948 46.948 0 0 1-3.187-4.146c-.89-1.309-1.773-2.773-2.432-4.232C5.719 12.2 5.3 10.777 5.3 9.54 5.3 5.873 8.292 2.9 12 2.9s6.7 2.973 6.7 6.64c0 1.237-.419 2.66-1.08 4.125-.66 1.459-1.543 2.923-2.433 4.232A47 47 0 0 1 12 22.043Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M12 12.7a3.1 3.1 0 0 1-3.1-3.1c0-1.711 1.389-3.1 3.1-3.1s3.1 1.389 3.1 3.1-1.389 3.1-3.1 3.1Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "pin"}) } }